import { documentTypeAliasesApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const DOCUMENT_TYPE_ALIASES_ACTION_TYPE = createNamedActions('documentTypeAliases', {
  GET_DOCUMENT_TYPE_ALIASES: 'GET_DOCUMENT_TYPE_ALIASES',
  CREATE_DOCUMENT_TYPE_ALIAS: 'CREATE_DOCUMENT_TYPE_ALIAS',
  DELETE_DOCUMENT_TYPE_ALIAS: 'DELETE_DOCUMENT_TYPE_ALIAS',
});

const documentTypeAliasSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getDocumentTypeAliasesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentTypeAliasesApi.getDocumentTypeAliases(params);

  return dispatch({
    type: DOCUMENT_TYPE_ALIASES_ACTION_TYPE.GET_DOCUMENT_TYPE_ALIASES,
    payload: normalize(data, [documentTypeAliasSchema]).entities.data || {},
  });
});

export const createDocumentTypeAliasAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentTypeAliasesApi.createDocumentTypeAlias(params);

  return dispatch({
    type: DOCUMENT_TYPE_ALIASES_ACTION_TYPE.CREATE_DOCUMENT_TYPE_ALIAS,
    payload: normalize(data, documentTypeAliasSchema).entities.data[data.id],
  });
});

export const deleteDocumentTypeAliasAction = catchAsyncActionError(params => async dispatch => {
  await documentTypeAliasesApi.deleteDocumentTypeAlias(params);

  return dispatch({
    type: DOCUMENT_TYPE_ALIASES_ACTION_TYPE.DELETE_DOCUMENT_TYPE_ALIAS,
    meta: params,
  });
});
